import repository from "@/repository/admin/index"

export default {
    async getCareGiverInfo({rootState, commit}) {
        const patient_id = rootState.adminDashboardMenuStore.patient_id;
        const {data} = await repository.getCareGiverInfo({patient_id})
        commit('SET_CARE_GIVER_DATA', data);
    }
}
